enum Theme {
  LIGHT = "light",
  DARK = "dark",
}

export const isValidTheme = (theme: any): theme is Theme =>
  theme === Theme.LIGHT || theme === Theme.DARK;

export default Theme;
